import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const getProducts = () => client.get("/products").then((r) => r.data);
export const getProduct = (id) =>
  client.get(`/products/${id}`).then((r) => r.data);
export const createProduct = (data) =>
  client.post("/products", data).then((r) => r.data);
export const updateProduct = (id, data) =>
  client.put(`/products/${id}`, data).then((r) => r.data);
export const deleteProduct = (id) =>
  client.delete(`/products/${id}`).then((r) => r.data);
export const createOrder = (data) =>
  client.post("/orders", data).then((r) => r.data);
export const getOrders = () => client.get("/orders").then((r) => r.data);
export const deleteOrder = (id) =>
  client.delete(`/orders/${id}`).then((r) => r.data);

export default client;
